import React, { useState, useContext, useEffect } from 'react';
import { systemCode, xs_languageCode, xs_isMobile } from '../..';
import MessageInfo from '../../common/MessageInfo';
import { getLabel } from '../../data/labels';
import { UserContext } from '../betslip/UserConf';
import { isSafari, iOS } from '../util/browserDetector';
import { getConfiguration } from '../utils';
import { getStreamingBalanceLimit } from './streamingUtils';
import $ from 'jquery';

function RadarStreaming(props) {
    const avPlayer = window.avvpl;
    const userContext = useContext(UserContext);
	const user = userContext.getUser();
    const matchId = props.matchId;
	const streamId = props.streamId;
	const ios = isSafari || iOS();
    const playerContainer = "radar-streaming-container-player";
	const balanceLimit =  getStreamingBalanceLimit();
	const isBalanceLimited = balanceLimit >0 && balanceLimit > user.balance;   
	const allowFullScreen = xs_isMobile;
	//const allowFullScreen = true;
    const [streamingData, setStreamingData] = useState({ status : 'not_loaded'});

	useEffect(() => {
		setStreamingData({status:'not_loaded'}); 
	}, [props.matchId]);
    
	// fetching streaming data from server
    if (streamingData.status === 'not_loaded' && user.logged && !isBalanceLimited && avPlayer != null) {
    	const url = getConfiguration().api.getLiveStreamingMatchData;
        const params = {
        		systemCode : systemCode,
    			hash : '',
    			lingua : xs_languageCode,
    			matchId,
    			streamId,
    			ios
        };
    	$.ajax({
    		type: "POST",
    		url : url + "?" +  $.param(params),
    		success : (data) => {
    			if(data == null){
    				setStreamingData({status:'not_avaiable'});   				
    			}
    			else{
    				data = JSON.parse(data);
    				setStreamingData({status:'ready', data}); 
    			}
    		},
    		error : (errorData) => {
    			console.error(errorData);
    			setStreamingData({status:'not_avaiable'}); 
    		}	
    	});
    	
    }
    useEffect(() => {
		setTimeout(() => {
			if(streamingData.status === 'ready') {
				let jsonData = streamingData.data;
				var urlSpecified = jsonData.url != null || (jsonData.stream != null && jsonData.stream.m3u8Uri != null) || (jsonData.stream != null && jsonData.stream.dashUri != null);
				if (urlSpecified === false) {
					setStreamingData({status:'not_avaiable'});   		
				} 
				else {
					setStreamingData({status:'loaded', data : jsonData}); 
				}
			}
			else if(streamingData.status === 'loaded'){
				let jsonData = streamingData.data;
				var type = "application/x-mpegURL";	
				var urlStreaming = jsonData.stream != null? (jsonData.stream.m3u8Uri || jsonData.stream.dashUri): jsonData.url;
				const player = new avPlayer.setupPlayer({
					id : playerContainer,
					allowFullScreen : allowFullScreen,
					controlBarVisible : false
				});
				player.load(urlStreaming, type);
				player.setMuted(false);
				player.setVolume(60);	
			}
		}, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [streamingData.status, streamingData.url]);

	try {
		return (
    		<div className="radar-tv-box-container">
                {user.logged?
                    (!isBalanceLimited ?
                        streamingData.status === 'not_loaded' ?
							<div className="bg-nero bianco" >{getLabel('live_page.stream_widget.loading')}</div>
                            :
                            streamingData.status === 'ready'?
								<div className="bg-nero bianco">{getLabel('live_page.stream_widget.preparing')}</div>
                                :
                                streamingData.status === 'loaded' ?
                                    <div id={playerContainer} className="radar-player-streaming-container"> </div>
                                    :
                                    <MessageInfo message={getLabel('live_page.stream_widget.stream_not_available')} />
                            :
                            <MessageInfo message={getLabel('live_page.stream_widget.insufficient_balance')} />
                    )
                    :
                    <MessageInfo message={getLabel('live_page.stream_widget.must_login')} />
                }
    		</div>
        );
	}catch(err) {
		return <MessageInfo message={getLabel('live_page.stream_widget.error')} />
	}
}

export default RadarStreaming;